export const occurrenceModules = [
  'single-occurrence',
  'weekly-occurrence',
  'monthly-occurrence',
] as const;

export type OccurrenceModule = (typeof occurrenceModules)[number];
